export default "__VITE_ASSET__VSLp$ryIOcKGxnpe5EdQMw__";